const PROFILE_PHOTOS = [
  '/assets/profile-photos/profile-diverse-europe-01-v2.webp',
  '/assets/profile-photos/profile-diverse-europe-02-v2.webp',
  '/assets/profile-photos/profile-diverse-europe-03-v2.webp',
  '/assets/profile-photos/profile-diverse-europe-04-v2.webp',
  '/assets/profile-photos/profile-diverse-europe-05-v2.webp',
  '/assets/profile-photos/profile-diverse-europe-06-v2.webp',
] as const;

interface ProfilePhotoStackProps {
  className?: string;
}

export function ProfilePhotoStack({ className = '' }: ProfilePhotoStackProps) {
  return (
    <span
      aria-hidden="true"
      className={`flex items-center justify-center -space-x-1 sm:-space-x-1.5 ${className}`}
      data-profile-photo-stack="true"
    >
      {PROFILE_PHOTOS.map((src, index) => (
        <span
          key={src}
          className="relative inline-flex h-5 w-5 shrink-0 overflow-hidden rounded-full shadow-[0_2px_7px_rgb(var(--theme-shadow)/0.16)] ring-2 ring-[rgb(var(--theme-surface))] sm:h-6 sm:w-6"
          style={{ zIndex: PROFILE_PHOTOS.length - index }}
        >
          <img
            src={src}
            alt=""
            className="h-full w-full object-cover"
            loading="lazy"
            decoding="async"
            draggable={false}
          />
        </span>
      ))}
    </span>
  );
}
